import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

import type { GetCatalogAssetsParams } from "@/types/catalogAssets";
import type { QueryClient } from "@tanstack/react-query";

import { catalogAssetsQueryOptions } from "@/api/products";
import { AssetDetailDialog } from "@/features/AssetLibrary/components/AssetDetailDialog";
import { catalogAssetToAssetMessage } from "@/features/AssetLibrary/utils/catalogAssetAdapter";

const DETAIL_LIST_PARAMS: GetCatalogAssetsParams = {
  approval_status: ["approved", "draft"],
  limit: 500,
};

export const Route = createFileRoute("/_auth/assets/$siteId/$assetKey")({
  loader: async ({ params, context }) => {
    const { queryClient } = context as { queryClient: QueryClient };
    await queryClient.ensureQueryData(
      catalogAssetsQueryOptions(params.siteId, DETAIL_LIST_PARAMS),
    );
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId, assetKey } = Route.useParams();
  const navigate = useNavigate({ from: "/assets/$siteId/$assetKey" });

  const listOptions = catalogAssetsQueryOptions(siteId, DETAIL_LIST_PARAMS);
  const { data } = useSuspenseQuery({
    queryKey: listOptions.queryKey,
    queryFn: listOptions.queryFn,
  });

  const close = () => {
    void navigate({
      to: "/assets/$siteId",
      params: { siteId },
      search: (prev) => prev,
    });
  };

  const match = data.assets.find((a) => a.handle === assetKey);
  if (!match) {
    // Asset isn't in the library (e.g. deleted or a stale URL) — return to list.
    close();
    return null;
  }

  return (
    <AssetDetailDialog
      asset={catalogAssetToAssetMessage(match)}
      open
      onClose={close}
    />
  );
}
